import { objectValues } from "@ea/shared_components/utils/object";

import * as codeTemplatesActions from "./codeTemplates.actions";
import codeTemplatesEpicsMap from "./codeTemplates.epics";
import * as codeTemplatesReducers from "./codeTemplates.reducers";

const codeTemplatesEpics = objectValues(codeTemplatesEpicsMap);

export { codeTemplatesActions, codeTemplatesReducers, codeTemplatesEpics };
